import { useContext, useEffect, useRef } from 'react';
import styles from './style.module.css';
import DropCtx from '../../context';
import cls from 'skin/entry/tool/cls';

export default function Pc({ className, style, maxHeight, children }) {
	const r = useRef();
	const { open, setOpen } = useContext(DropCtx);
	useEffect(() => {
		const fn = ev => {
			if (r.current.contains(ev.target)) return;
			setOpen(false);
		}
		const doc = window.document;
		doc.addEventListener('click', fn);
		return _ => doc.removeEventListener('click', fn);
	}, [open]);
	return <div className={styles.wrap} style={maxHeight ? { maxHeight } : null} ref={r}>
		<div className={cls(styles.body, className).join()} style={style}>
			{children}
		</div>
	</div>
}